import { render, staticRenderFns } from "./modal_criar_agenda.vue?vue&type=template&id=6c7a86bd&scoped=true"
import script from "./modal_criar_agenda.vue?vue&type=script&lang=js"
export * from "./modal_criar_agenda.vue?vue&type=script&lang=js"
import style0 from "./modal_criar_agenda.vue?vue&type=style&index=0&id=6c7a86bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7a86bd",
  null
  
)

export default component.exports